/** Flags do React Router v7 já adotadas (evita mudança de comportamento no upgrade). */
export const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true } as const
